import React, { useCallback, useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { RightOutlined } from '@ant-design/icons';
import 'Assets/styles/default/components/CartVoucher/index.less'

// DS
import { Row, VertContainer, VertBreadcrumb, VertIcon, Col } from '@vertem-core/vertice-ds';

// COMPONENTS
import { SearchSidebar, SearchTopbar } from 'components/SearchSidebar';
import Pagination from 'components/Pagination/Pagination';
import SearchTopFilter from 'components/SearchSidebar/SearchTopFilters';
import CategoryItems from './CategoryItems';
import CategoryWrapper from './CategoryWrapper';
import { useSelector } from "react-redux";
import PipeProvider from "../../Services/Providers/PipeProvider";
import StoreListPlaceholder from "../../components/Store/Presentation/StoreListPlaceholder";

const breadcrumbMock = [
  {
    title: 'Início',
    path: '/',
  },
  {
    title: 'Vales-compra',
    path: '/vouchers',
  },
]

// VOUCHER PAGE
const VoucherPage = () => {
  /* Hooks */
  const isLargeScreen = useMediaQuery({ minWidth: 769 });
  const Stores = useSelector(({ Stores }) => Stores)
  const [page, setPage] = useState(1)
  const [filterByText, setFilterByText] = useState(null)
  const [searchResults, setSearchResults] = useState(null)

  /* States */
  const [searchSidebarVisible, setSearchSidebarVisible] = useState(false);
  const filterItemsBySearch = useCallback(() => {
    const Exp = new RegExp(`(${filterByText})`, 'i');
    const result = Stores.vouchers.filter(({ name }) => Exp.test(name))
    setSearchResults(result)
  }, [filterByText, Stores.vouchers])
  /* Vars */
  const wrapperGutterValue = isLargeScreen ? 20 : 0;
  /* Renders */
  useEffect(() => {
    if (filterByText) {
      setPage(1)
      filterItemsBySearch()
    } else if (!filterByText && filterByText !== null) {
      setPage(1)
      setFilterByText(null)
      setSearchResults(null)
    }
  }, [filterByText]);
  return (
    <>
      <PipeProvider
        apiSymbols={[
          {
            symbol: 'FETCH_STORES',
            alias: 'vouchers_page',
            payload: {}
          }
        ]}
        loadingComponent={<StoreListPlaceholder />}
      >
        <VertContainer>
          <Row
            className={'margin-x-none'}
          >
            <Col span={24} className='padding-x-regular padding-top-regular'>
              <VertBreadcrumb hasBackButton={true}
                separator={<VertIcon component={RightOutlined} />}
                items={breadcrumbMock}
              />
            </Col>
          </Row>
        </VertContainer>
        <VertContainer className="vert-container-page" spacingX="regular" spacingY="regular">
          <SearchTopbar
            disableOrderFilter
            productLabel={'vouchers'}
            staticData={((Stores.vouchers.length) && (
              {
                totalRowCount: Stores.vouchers.length
              }
            )) || null}
          />
          <Row gutter={wrapperGutterValue}>
            <SearchSidebar
              searchSidebarVisible={searchSidebarVisible}
              toggleSearchSidebar={setSearchSidebarVisible}
              drawerClassName="vert-sidebar-voucher"
            >
              <SearchTopFilter
                onSearch={(search) => {
                  setFilterByText(search)
                }}
              />
            </SearchSidebar>
            <CategoryWrapper>
              <CategoryItems
                isVoucher
                items={(searchResults || Stores.vouchers).sort((a, b) => {
                  if (a.name.toLowerCase() > b.name.toLowerCase()) {
                    return 1;
                  }
                  if (a.name.toLowerCase() < b.name.toLowerCase()) {
                    return -1;
                  }
                  // a must be equal to b
                  return 0;
                }).slice((page - 1) * 24, page * 24).map(({ name, id, imageUrl, customUrlPage, supplierId }) => ({
                  imageUrl,
                  name,
                  originalId: id,
                  supplierId,
                  productUrl: customUrlPage || '',
                  rating: { average: 0, totalCount: 5 },
                  colProps: {
                    className: '',
                  },
                }))}
              />
            </CategoryWrapper>
          </Row>
          <Pagination
            total={(searchResults || Stores.vouchers).length}
            pageSize={24}
            current={page}
            callback={(e) => {
              setPage(e)
            }}
          />
        </VertContainer>
      </PipeProvider>
    </>
  );
};

export default VoucherPage;
